import { formatErrorDetails } from '../../../utils/error'

export function errorHandler(error: any): string[] {
  if (!error.response?.data) return []

  const messages = formatErrorDetails(error.response?.data)

  return messages
}
